import {
  SUBMIT_FEEDBACK_REQUEST,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR,
  RESET_FEEDBACK
} from "../constants/action-types";
import ApiService from "../../utils/ApiService";

export const submitFeedback = async (dispatch, { feedbackUrl, payload }) => {
  dispatch({
    type: SUBMIT_FEEDBACK_REQUEST
  });
  try {
    await ApiService.postFeedback(feedbackUrl, payload);
    dispatch({
      type: SUBMIT_FEEDBACK_SUCCESS
    });
  } catch (error) {
    dispatch({
      type: SUBMIT_FEEDBACK_ERROR
    });
  }
};

export const resetFeedback = (dispatch) =>
  dispatch({
    type: RESET_FEEDBACK
  });
